import { AuthClassification } from 'src/hooks/auth/auth.interface';
import { routesByDefault, routesForOwnerOperator } from 'src/routes';

export const getRouterWithRoles = (userRole: AuthClassification | null) => {
  switch (userRole) {
    case AuthClassification.ADMINISTRATOR:
      return routesByDefault;
    case AuthClassification.OWNER_OPERATOR:
      return routesForOwnerOperator;
    default:
      return routesByDefault;
  }
};
